import React from "react";
import styles from "./AdminNetwork.module.scss";
import AdminAside from "../../components/AdminAside/AdminAside";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import Main from "./components/Main";
const AdminNetwork = ({
  openModal,
  role,
  setIsOpenModal,
  referalValue,
  currentLang,
  setCurrentLang,
}) => {
  return (
    <div className={styles.wrapper}>
      <AdminAside setIsOpenModal={setIsOpenModal} isOpenModal={openModal}  role={role} />
      <div className={styles.container}>
        <AdminHeader
          openModal={openModal}
          setIsOpenModal={setIsOpenModal}
          referalValue={referalValue}
          currentLang={currentLang}
          setCurrentLang={setCurrentLang}
          role={role}
        />
        <Main role={role} />
      </div>
    </div>
  );
};

export default AdminNetwork;
